<template>
    <div>
        <!-- Banner Start -->
        <template v-if="is_Update && user_role == 1">
            <button v-if="banner_image != ''" type="submit" class="themebutton mt-2 ml-2 mb-2 btn btn-primary pull-right" v-on:click.prevent="cancelBanner()"><span>Cancel</span></button>
            <button type="submit" class="themebutton mt-2 ml-2 mb-2 btn btn-primary pull-right" v-on:click.prevent="addUpdateBanner('add')"><span>Add</span></button>
            <div class="clearfix"></div>
            <vue-dropzone
                ref="myVueDropzone" id="dropzone" 
                :options="dropzoneOptions"
                @vdropzone-success = "uploadBanner"
                @vdropzone-removed-file="removedSelectedFile"
                :useCustomSlot=true
                >
                <div class="dropzone-custom-content">
                    <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                    <div class="subtitle">(Select files from your computer.)</div>
                </div>
            </vue-dropzone>
            <div class="mb-3 help is-danger">{{banner_error_msg}}</div>

        </template>
        <template v-else>
            <div v-if="banner_image != '' && (status == 'active' || user_role == 1)" class="pagebanner">
                <img :src="banner_image">
                <div v-if="user_role == 1" class="banner-btns">
                    <button title="Edit" type="submit" class="ml-2 btn btn-primary pull-right" v-on:click.prevent="editBanner('edit')"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                    <button title="Inactive" v-show="status == 'active'" type="submit" class="ml-2 btn btn-primary pull-right" v-on:click.prevent="statusBanner('inactive')"><i class="fa fa-eye-slash" aria-hidden="true"></i></button>
                    <button title="Active" v-show="status == 'inactive'" type="submit" class="ml-2 btn btn-primary pull-right" v-on:click.prevent="statusBanner('active')"><i class="fa fa-eye" aria-hidden="true"></i></button>
                    <button title="Delete" type="submit" class="ml-2 btn btn-primary pull-right" v-on:click.prevent="deleteBanner()"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                </div>
            </div>
            <div class="clearfix"></div>
        </template>
    </div>
</template>

<script>
    import Vue from 'vue';
    import vue2Dropzone from 'vue2-dropzone';
    import {commonMixins} from '../../mixins/commonMixins';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import {HTTP} from '../../http-common.js';
    import { Button } from 'bootstrap-vue/es/components';

    Vue.component("vueDropzone", vue2Dropzone);
    export default {
        name: 'CommonPage',
        mixins: [commonMixins],
        data() {
            return {
                //user_role: 0,
                is_Update: false,
                status: 'active',
                banner_data: "",
                menuSlug: "",
                fileHeigth: "",
                fileSize: "",
                fileType: "",
                imagePath: "",
                banner_image: "",
                banner_error_msg: "",
                dropzoneOptions: {
                    url: process.env.ROOT_API + "/store_media_banner",
                    method: "POST",
                    autoProcessQueue: true,
                    maxFilesize: 25, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    maxFiles: 1,
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    dictCancelUpload: 'Cancel',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    }
                },
            }
        },
        watch: {
            '$route': function () {
                var self = this;
                self.loadBannerData();
            }
        },
        created: function () {

        },
        mounted: function () {
            var self = this;
            self.loadBannerData();
        },

        methods: {
            loadBannerData: function () {
                var self = this;
                self.menuSlug = this.$route.params.type;
                self.loadBanner();
                /* Get Role for conditionally provide add/edit feature */
                /*setTimeout(function () {
                 self.user_role = localStorage.getItem("user_role");
                 }, 300);
                 */
            },
            //if image size is not proper throws the validation and remove the all images
            removeAllFiles: function () {
                var self = this;
                self.$refs.myVueDropzone.removeAllFiles();
            },
            removedSelectedFile: function (file, xhr, error) {

                var self = this;
                var removeFile = self.imagePath;
                self.removeFileFromServer(removeFile);
            },

            removeFileFromServer: function (filePath) {

                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("tkn")},
                    data: {
                        filePath: filePath,
                    }
                };
                self.showLoader();
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                            self.imagePath = "";
                            self.fileType = "";
                            self.fileSize = "";
                            self.fileWidth = "";
                            self.fileHeight = "";
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            //open popup window and display image and store image in temp folder.
            uploadBanner:function (file, response) {
                var self = this;
                self.imagePath = response.content;

                self.fileWidth = file.width;
                self.fileHeight = file.height;
                self.fileSize = file.size;
                self.fileType = file.type;
                self.banner_error_msg = "";

                /* if (self.fileHeight % 120 != 0 || !(self.fileHeight >= 120) || !(self.fileHeight <= 240)
                 || self.fileWidth % 506 != 0 || !(self.fileWidth >= 506 || !(self.fileWidth <= 1012))) {
                 
                 self.removeAllFiles();
                 self.banner_error_msg = "Please Upload Image In This Dimensions Only.(Height : 240 pixel, Width 1012 pixel)";
                 } */
            },

            //if Banner image is exists then laod banner and stroe banner url in banner_image varibale
            loadBanner:function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {'slug': self.menuSlug, }
                };

                self.showLoader();
                HTTP.get("get_menu_details", config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                //console.log(response.data.content.banner.id)
                                if (typeof (response.data.content.banner.id) != 'undefined') {
                                    self.status = response.data.content.banner.status;
                                    self.banner_image = response.data.content.banner.url;
                                    self.banner_data = response.data.content.banner;
                                    self.is_Update = false;
                                } else {
                                    self.status = "inactive";
                                    self.banner_image = "";
                                    self.is_Update = true;
                                }
                                self.menu_id = response.data.content.menu_details.id;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },

            cancelBanner:function () {
                var self = this;
                if (self.banner_image != '') {
                    self.is_Update = false;
                }
            },

            statusBanner:function (stat) {
                var self = this;
                //self.is_Update = true;

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                };

                var fields = {
                    'menu_id': self.menu_id
                };

                self.$swal({
                    title: 'Are you sure?',
                    text: "You want to " + stat + " banner ?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes change it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.post('banner_status_change', fields, config)
                                .then(function (response) {
                                    if (response.data.status == 'success') {
                                        self.$swal({
                                            title: "Banner Status Change successfully",
                                            text: "You clicked the button!",
                                            type: "success",
                                        });

                                        self.status = response.data.content.status;

                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                    }
                });

            },

            deleteBanner:function () {
                var self = this;
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                    data: {
                        'menu_id': self.menu_id
                    }
                };
                self.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.showLoader();
                        HTTP.delete('delete_banner', config)
                                .then(function (response) {
                                    if (response.data.status == 'success') {
                                        self.$swal({
                                            title: "Banner Deleted Successfully",
                                            text: "You clicked the button!",
                                            type: "success",
                                        });
                                        self.is_Update = true;
                                        self.banner_image = "";
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });

                    }
                });
            },

            editBanner:function () {
                var self = this;
                self.is_Update = true;
                if (self.banner_data.url != '') {
                    self.uploadManually(self.banner_data);
                }
            },

            uploadManually:function (file) {
                var self = this;

                var url = file.url;
                var file_name = self.getFileName(file.url);
                var file_type = self.getFileType('jpg');
                var file_size = file.image_size;

                self.attachmentType = file_type;
                self.attachmentSize = Number(file_size);
                var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                setTimeout(function () {
                    self.$refs.myVueDropzone.manuallyAddFile(file_data, url);
                }, 100);
            },
            getFileName: function (file) {

                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]

                self.attachmentPaths = String(orgPath + "/" + file_name);

                return file_name;
            },

            getFileType: function (file_name) {

                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },

            //submit banner from and stroe all details of banner and module inforamtion
            addUpdateBanner:function (flag) {

                var self = this;
                var error = false;
                self.banner_error_msg = "";

                if (flag != 'add') {
                    self.is_Update = true;
                }

                if (self.imagePath == null || self.imagePath == "") {
                    self.banner_error_msg = "Required Banner.";
                    error = true;
                }

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                };
                var fields = {
                    'type': self.fileType,
                    'width': self.fileWidth,
                    'height': self.fileHeight,
                    'tempPath': self.imagePath,
                    'size': self.fileSize,
                    'slugType': self.menuSlug,
                };

                if (!error) {
                    self.showLoader();
                    HTTP.post("add_banner", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.sliderData = response.data.content;
                                    self.removeAllFiles();
                                    self.is_Update = false;
                                    self.banner_image = response.data.content.url;
                                    self.status = "active";
                                    self.banner_data = response.data.content;
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("tkn");
                                        self.$router.push("/");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            });
                }
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Banner/BannerComponents.vue